import { authorizedRequest, HTTP_METHODS } from "../../utils/request";

export async function Paginator(url, filter, limit, offset) {
  try {
    const method = HTTP_METHODS.POST;

    const params = {};

    if (limit !== undefined) {
      params.limit = limit;
    }

    if (offset !== undefined) {
      params.offset = offset;
    }

    let body = { filter };

    if (typeof filter === "object") {
      body = { ...filter };
    }

    const result = await authorizedRequest(url, {
      method,
      body,
      params,
    });

    return CalculatePages(result);
  } catch (e) {
    return e.response;
  }
}

export function CalculatePages(result) {
  const resultObject = result;
  resultObject.PageNumbers = Math.ceil(result.total / result.limit);

  return resultObject;
}
